import filter from "./filter.js";
export default function compact(array) {
  return filter(array, Boolean);
}
